module.exports = __webpack_public_path__ + "assets/img/FnklCR3V-WFYYEc6o_eCAGzJ6m08.dc530782.png";